export default __webpack_public_path__ + "static/media/7.ce842827.jpg";